module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/grey arrow-eff447f3.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/grey arrow.svg
// module id = ./app/web/src/assets/grey arrow.svg
// module chunks = 0